import { Minus, Plus, Utensils } from "lucide-react";
import { formatRupiah, imageUrl } from "@/lib/api";
import { GROUPS, hasOptions } from "@/lib/options";

export const MenuItem = ({ p, qty, onChange }) => (
  <div
    className={`flex items-center gap-3 rounded-2xl border bg-white p-4 transition-colors ${qty ? "border-emerald-300" : "border-slate-200"} ${p.available ? "" : "opacity-60"}`}
    data-testid={`menu-item-${p.id}`}
  >
    <div className="flex h-20 w-20 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-emerald-50 text-emerald-300">
      {p.image_path ? <img src={imageUrl(p.image_path)} alt={p.name} loading="lazy" className="h-full w-full object-cover" data-testid={`menu-item-photo-${p.id}`} /> : <Utensils className="h-6 w-6" />}
    </div>
    <div className="min-w-0 flex-1">
      <p className="text-[10px] font-semibold uppercase tracking-wider text-slate-400">{p.category}</p>
      <p className="font-semibold text-slate-800">{p.name}</p>
      <p className="mt-1 font-mono font-bold text-emerald-700">{formatRupiah(p.price)}</p>
      {hasOptions(p) && <p className="mt-0.5 text-xs text-slate-500" data-testid={`menu-item-has-options-${p.id}`}>Bisa pilih {GROUPS.filter((g) => p[g.key]?.enabled && p[g.key].items?.length).map((g) => g.label.toLowerCase()).join(", ")}</p>}
    </div>
    {!p.available ? (
      <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-bold text-red-700" data-testid={`menu-item-soldout-${p.id}`}>Habis</span>
    ) : qty ? (
      <div className="flex items-center gap-2">
        <button onClick={() => onChange(p, -1)} className="flex h-9 w-9 items-center justify-center rounded-full border border-slate-200 text-slate-700 hover:bg-slate-50" data-testid={`menu-qty-decrease-${p.id}`}><Minus className="h-4 w-4" /></button>
        <span className="w-6 text-center font-mono font-bold" data-testid={`menu-qty-${p.id}`}>{qty}</span>
        <button onClick={() => onChange(p, 1)} className="flex h-9 w-9 items-center justify-center rounded-full bg-emerald-600 text-white hover:bg-emerald-700" data-testid={`menu-qty-increase-${p.id}`}><Plus className="h-4 w-4" /></button>
      </div>
    ) : (
      <button onClick={() => onChange(p, 1)} className="rounded-full bg-emerald-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-emerald-700" data-testid={`menu-add-${p.id}`}>
        Tambah
      </button>
    )}
  </div>
);
